import { BiDraftView } from '@euler/model/bi/draft';
import {
  BiDatasetList,
  BiUploadedDatasetDetail,
} from '@euler/model/bi/library';
import { BiQueryResult } from '@euler/model/bi/result';

// Captured from the dev rear (store 323, member 3855) over the BiService hop
// on 2026-10-17: the usable uploads, their details, and a blend of monthly
// orders with the uploaded monthly targets (the draft was deleted after).

export const kBiMineDatasetsCaptured = {
  section: 'mine',
  datasets: [
    {
      kind: 'upload',
      dataset: {
        id: 'bids_01m53vy5pdr6g6b0rnadpyejdc',
        name: '月度工单目标',
        description: null,
        ownerMemberId: 3855,
        ownerName: '王店长',
        visibility: 1,
        versionId: 'bidsv_01m53vy5pdv8pf0nkq4h7dmm86',
        versionNo: 1,
        rowCount: 12,
        columnCount: 2,
        sourceFileName: null,
        sourceSheet: null,
        createdAt: '2026-10-17T02:44:30.000Z',
        updatedAt: '2026-10-17T02:44:30.000Z',
        lastUsedAt: '2026-10-17T03:40:33.000Z',
        permission: 'manage',
        usage: { dashboardCount: 0, cardCount: 0 },
      },
    },
    {
      kind: 'upload',
      dataset: {
        id: 'bids_01m53wkcj3kacpzdphw877py6k',
        name: '供应商评分表',
        description: null,
        ownerMemberId: 3855,
        ownerName: '王店长',
        visibility: 1,
        versionId: 'bidsv_01m53wkcj3h975zsxmzpea62xp',
        versionNo: 1,
        rowCount: 3,
        columnCount: 2,
        sourceFileName: null,
        sourceSheet: null,
        createdAt: '2026-10-17T02:56:05.000Z',
        updatedAt: '2026-10-17T02:56:05.000Z',
        lastUsedAt: null,
        permission: 'manage',
        usage: { dashboardCount: 0, cardCount: 0 },
      },
    },
  ],
} as unknown as BiDatasetList;

export const kBiUploadedDetailsCaptured = [
  {
    kind: 'upload',
    dataset: {
      id: 'bids_01m53vy5pdr6g6b0rnadpyejdc',
      name: '月度工单目标',
      description: null,
      ownerMemberId: 3855,
      ownerName: '王店长',
      visibility: 1,
      versionId: 'bidsv_01m53vy5pdv8pf0nkq4h7dmm86',
      versionNo: 1,
      rowCount: 12,
      columnCount: 2,
      sourceFileName: null,
      sourceSheet: null,
      createdAt: '2026-10-17T02:44:30.000Z',
      updatedAt: '2026-10-17T02:44:30.000Z',
      lastUsedAt: '2026-10-17T03:40:33.000Z',
      permission: 'manage',
      usage: { dashboardCount: 0, cardCount: 0 },
    },
    catalog: {
      dataset: { kind: 'upload', datasetId: 'bids_01m53vy5pdr6g6b0rnadpyejdc' },
      label: { zh: '月度工单目标', en: '月度工单目标' },
      description: { zh: '每个月的开单目标', en: '每个月的开单目标' },
      primaryTime: 'f_month',
      fields: [
        {
          key: 'f_month',
          label: { zh: '月份', en: '月份' },
          role: 'dimension',
          type: 'date',
          grains: ['day', 'week', 'month', 'quarter', 'year'],
          conformedKey: 'date',
        },
        {
          key: 'row_count',
          label: { zh: '行数', en: 'rows' },
          role: 'measure',
          type: 'number',
          aggs: [],
        },
        {
          key: 'f_target',
          label: { zh: '目标工单数', en: '目标工单数' },
          role: 'measure',
          type: 'number',
          aggs: ['sum', 'avg', 'min', 'max', 'count', 'count_distinct'],
          defaultAgg: 'sum',
        },
      ],
    },
    usageDetail: { dashboards: [], hiddenDashboardCount: 0, cardCount: 0 },
  },
  {
    kind: 'upload',
    dataset: {
      id: 'bids_01m53wkcj3kacpzdphw877py6k',
      name: '供应商评分表',
      description: null,
      ownerMemberId: 3855,
      ownerName: '王店长',
      visibility: 1,
      versionId: 'bidsv_01m53wkcj3h975zsxmzpea62xp',
      versionNo: 1,
      rowCount: 3,
      columnCount: 2,
      sourceFileName: null,
      sourceSheet: null,
      createdAt: '2026-10-17T02:56:05.000Z',
      updatedAt: '2026-10-17T02:56:05.000Z',
      lastUsedAt: null,
      permission: 'manage',
      usage: { dashboardCount: 0, cardCount: 0 },
    },
    catalog: {
      dataset: { kind: 'upload', datasetId: 'bids_01m53wkcj3kacpzdphw877py6k' },
      label: { zh: '供应商评分表', en: '供应商评分表' },
      description: { zh: '配件供应商的评分', en: '配件供应商的评分' },
      fields: [
        {
          key: 'f_supplier',
          label: { zh: '供应商', en: '供应商' },
          role: 'dimension',
          type: 'string',
        },
        {
          key: 'row_count',
          label: { zh: '行数', en: 'rows' },
          role: 'measure',
          type: 'number',
          aggs: [],
        },
        {
          key: 'f_score',
          label: { zh: '评分', en: '评分' },
          role: 'measure',
          type: 'number',
          aggs: ['sum', 'avg', 'min', 'max', 'count', 'count_distinct'],
          defaultAgg: 'sum',
        },
      ],
    },
    usageDetail: { dashboards: [], hiddenDashboardCount: 0, cardCount: 0 },
  },
] as unknown as BiUploadedDatasetDetail[];

export const kBiBlendResultCaptured = {
  columns: [
    {
      key: 'date__month',
      label: { zh: '开单时间（月）', en: 'Opened at (month)' },
      type: 'string',
      role: 'dimension',
    },
    {
      key: 'q1__order_count',
      label: { zh: '工单数（工单）', en: 'Orders (Orders)' },
      type: 'number',
      role: 'measure',
      format: { kind: 'number', decimals: 0 },
      side: 0,
    },
    {
      key: 'q2__f_target',
      label: {
        zh: '目标工单数（月度工单目标）',
        en: '目标工单数 (月度工单目标)',
      },
      type: 'number',
      role: 'measure',
      side: 1,
    },
  ],
  rows: [
    ['2025-11', 1494, 200],
    ['2025-12', 1501, 210],
    ['2026-01', 1687, 220],
    ['2026-02', 1643, 230],
    ['2026-03', 1579, 240],
    ['2026-04', 1407, 250],
    ['2026-05', 1236, 260],
  ],
  truncated: false,
  asOf: '2026-10-17T03:40:40.877Z',
} as unknown as BiQueryResult;

export const kBiBlendDraftCaptured = {
  id: 'bidraft_01m53z53jrwcnktt2v8e5czq3p',
  title: '每月开单量 vs 目标',
  spec: {
    kind: 'blend',
    queries: [
      {
        dataset: { kind: 'sql', model: 'orders' },
        measures: [{ kind: 'field', field: 'order_count' }],
        dimensions: [{ field: 'created_at', grain: 'month' }],
        filters: [],
        sort: [],
        timeRange: { kind: 'relative', preset: 'last_12_months' },
      },
      {
        dataset: {
          kind: 'upload',
          datasetId: 'bids_01m53vy5pdr6g6b0rnadpyejdc',
        },
        measures: [{ kind: 'field', field: 'f_target' }],
        dimensions: [{ field: 'f_month', grain: 'month' }],
        filters: [],
        sort: [],
      },
    ],
    on: [{ key: 'date', grain: 'month' }],
    join: 'left',
  },
  viz: {
    type: 'line',
    x: 'date__month',
    series: [{ key: 'q1__order_count' }, { key: 'q2__f_target' }],
  },
  result: {
    current: {
      columns: [
        {
          key: 'date__month',
          label: { zh: '开单时间（月）', en: 'Opened at (month)' },
          type: 'string',
          role: 'dimension',
        },
        {
          key: 'q1__order_count',
          label: { zh: '工单数（工单）', en: 'Orders (Orders)' },
          type: 'number',
          role: 'measure',
          format: { kind: 'number', decimals: 0 },
          side: 0,
        },
        {
          key: 'q2__f_target',
          label: {
            zh: '目标工单数（月度工单目标）',
            en: '目标工单数 (月度工单目标)',
          },
          type: 'number',
          role: 'measure',
          side: 1,
        },
      ],
      rows: [
        ['2025-11', 1494, 200],
        ['2025-12', 1501, 210],
        ['2026-01', 1687, 220],
        ['2026-02', 1643, 230],
        ['2026-03', 1579, 240],
        ['2026-04', 1407, 250],
        ['2026-05', 1236, 260],
      ],
      truncated: false,
      asOf: '2026-10-17T03:40:40.906Z',
    },
  },
  parentDraftId: null,
  rationale: null,
  createdAt: '2026-10-17T03:40:40.000Z',
  expiresAt: '2026-11-16T03:40:40.000Z',
} as unknown as BiDraftView;
